import { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import firebase from 'firebase'

export const useAnonymAuth = () => {
    const { isLoaded, isEmpty, isAnonymous } = useSelector((state: any) => state.firebase.auth)

    useEffect(
        () => {
            if (!isLoaded || !isEmpty) return

            firebase
                .auth()
                .signInAnonymously()
                .catch(({ code, message }) => {
                    if (code === 'auth/operation-not-allowed') {
                        console.error('You must enable Anonymous auth in the Firebase Console.')
                    } else {
                        console.error(message, 'signInAnonymously')
                    }
                })
        },
        // we need to ignore isEmpty, otherwise you will not be able to sign out,
        // it will automatically sign you in back

        // eslint-disable-next-line react-hooks/exhaustive-deps
        [isLoaded]
    )

    return useMemo(
        () => ({
            isLoggedIn: !isEmpty,
            isAnonymous,
            isLoadingAuth: !isLoaded
        }),
        [isAnonymous, isEmpty, isLoaded]
    )
}
